import httpClient from "./httpClient";
const getIssues = (payload) => httpClient.get(`/record/redmine-issues/?project_id=${payload.project_id}`)



export {
    getIssues,
}